const birthdayQueryKeys = {
  all: ['all', 'birthday'] as const,
  birthdayLists: () => [...birthdayQueryKeys.all, 'birthdayList'] as const,
  birthdayList: (organisation: string) => [...birthdayQueryKeys.birthdayLists(), { organisation }] as const,
  upcomingBirthdayLists: () => [...birthdayQueryKeys.all, 'upcomingBirthday'] as const,
  upcomingBirthdayList: () => [...birthdayQueryKeys.upcomingBirthdayLists()] as const,
}

export default birthdayQueryKeys
